(() => {
  const rootSelector = '.js-redesign-root';
  const revealSelector = `${rootSelector} .r-reveal`;
  const stickyCtas = document.querySelectorAll(`${rootSelector} .r-sticky-cta`);

  if (stickyCtas.length) {
    const updateStickyCtas = () => {
      const shouldShow = window.scrollY > Math.min(window.innerHeight * 0.72, 680);
      stickyCtas.forEach((node) => node.classList.toggle('is-visible', shouldShow));
    };

    updateStickyCtas();
    window.addEventListener('scroll', updateStickyCtas, { passive: true });
    window.addEventListener('resize', updateStickyCtas);
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(revealSelector).forEach((node) => node.classList.add('is-visible'));
    return;
  }

  const revealNodes = document.querySelectorAll(revealSelector);
  if (!revealNodes.length || !('IntersectionObserver' in window)) {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

  revealNodes.forEach((node) => observer.observe(node));
})();
